/* eslint-disable no-console */
import { EventBus } from "@/setup/event-bus";
import { Workbox } from "workbox-window";

if ("serviceWorker" in navigator) {
  const wb = new Workbox("/service-worker.js");

  wb.addEventListener("activated", (event) => {
    console.log("[wb] activated event", event);
    // `event.isUpdate` will be true if another version of the service
    // worker was controlling the page when this version was registered.
    if (!event.isUpdate) {
      EventBus.$emit("service-worker-installed");
    }
  });

  wb.addEventListener("installed", (event) => {
    console.log("[wb] service worker installed event: ", event);
    if (event.isUpdate) {
      /* EventBus.$emit('app-shell-update') */
    }
  });

  window.addEventListener("load", () => {
    console.log("[wb] service worker loaded event");
    const reg = wb.register();

    reg.then((registration) => {
      console.log("[wb] service worker registered", registration);
      registration.addEventListener("updatefound", () => {
        const installingWorker = registration.installing;
        console.log("[wb] service worker installed 2");
        installingWorker.addEventListener("statechange", () => {
          switch (installingWorker.state) {
            case "installed":
              if (navigator.serviceWorker.controller) {
                console.log("[wb] service worker installed 3");
                /* EventBus.$emit('app-shell-update') */
              }
              break;
          }
        });
      });
    });
  });
}

let deferredPrompt;
window.addEventListener("beforeinstallprompt", (e) => {
  deferredPrompt = e;
  console.log("Webapp ready to get installed.");
  EventBus.$emit("show-install-prompt", deferredPrompt);
});

window.addEventListener("appinstalled", (e) => {
  console.log("Successfully installed web app.");
  EventBus.$emit("installed-web-app", e);
});
